import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { parse } from 'date-fns';

// import router from '../router/router';

Vue.use(Vuex);
// const

Vue.config.devtools = true;

export default new Vuex.Store({
  state: {
    kurse: [], // from API
    gruppen: [], // from API
    arten: [], // from API
    filter: {
      gruppe: null,
      art: null,
      dateStart: null,
      dateEnd: null,
      volltext: '',
    },
    // ready flags
    readyKurse: false,
    readyArten: false,
    readyGruppen: false,
    ready: false,
    firstRun: true,
    // gefilterte Kurse, werden im Getter ausgewertet.
    buchungBaseURL1: 'https://portal.zaek-nr.de/kursanmeldung/',
    buchungBaseURL2: 'https://portal.zaek-nr.de/kursinteresse/',
  },
  actions: {
    loadKurse(context) {
      axios
        .get('https://www.khi-direkt.de/api/kurse/list/')
        .then((response) => {
          context.state.kurse = response.data;
          context.state.readyKurse = true;
        })
        .catch((error) => {
          console.log('error on kurs api:', error);
        });
    },
    loadArten(context) {
      axios
        .get('https://www.khi-direkt.de/api/kurse/arten/')
        .then((response) => {
          context.state.arten = response.data;
          context.state.readyArten = true;
        })
        .catch((error) => {
          console.log('Error in Arten API CALL:', error);
        });
    },
    loadGruppen(context) {
      axios
        .get('https://www.khi-direkt.de/api/kurse/gruppen/')
        .then((response) => {
          context.state.gruppen = response.data;
          context.state.readyGruppen = true;
        })
        .catch((error) => {
          console.log('Error in Gruppen API CALL:', error);
        });
    },
  },
  mutations: {
    setSelectedGruppe(state, newGruppeVal) {
      console.log(`store: setSelectedGruppe: ${newGruppeVal}`);
      state.selectedGruppe = newGruppeVal;
      state.firstRun = false;
    },
    setSelectedArt(state, payload) {
      console.log(`store: setSelectedArt: ${payload}`);
      state.selectedArt = payload;
    },
    setFilter(context, filterObj) {
      console.log('setting filter: ', filterObj);
      context.filter[filterObj.type] = filterObj.val;
      context.firstRun = false;
    },
  },
  getters: {
    ready: state => state.readyArten && state.readyKurse && state.readyGruppen,
    firstRun: state => state.firstRun,
    gruppen: state => state.gruppen,
    kurse: state => state.kurse,
    arten: state => state.arten,
    filter: state => state.filter,
    buchungBaseURL1: state => state.buchungBaseURL1,
    buchungBaseURL2: state => state.buchungBaseURL2,
    // neuer filter
    kursliste(state) {
      let arr = state.kurse;
      if (state.filter.gruppe && state.filter.gruppe !== 0) {
        arr = _.filter(arr, item => item.gruppen.indexOf(state.filter.gruppe) > -1);
      }
      if (state.filter.art && state.filter.art !== 0 && state.filter.art !== '0') {
        // arr = _.filter(arr, item => item.arten.indexOf(state.filter.art) > -1);
        arr = _.filter(arr, item => item.kat_zaek.indexOf(state.filter.art) > -1);
      }
      if (state.filter.dateStart) {
        const startDate = new Date(parse(state.filter.dateStart, 'dd.MM.yyyy', new Date()));
        arr = _.filter(arr, item => item.kursstartdatum >= Math.round(startDate.getTime() / 1000));
      }
      if (state.filter.dateEnd) {
        const endDate = new Date(parse(state.filter.dateEnd, 'dd.MM.yyyy', new Date()));
        endDate.setHours(23, 59, 0, 0);
        arr = _.filter(arr, item => item.kursenddatum <= Math.round(endDate.getTime() / 1000));
      }
      if (state.filter.volltext.length > 1) {
        let searchTermArr = [];
        if (state.filter.volltext.indexOf(' ') > -1) {
          searchTermArr = state.filter.volltext.split(' ');
        } else {
          searchTermArr.push(state.filter.volltext);
        }
        console.log('suchwort', searchTermArr);
        arr = _.filter(arr, (item) => {
          let treffer = 0;
          for (let index = 0; index < searchTermArr.length; index += 1) {
            const element = searchTermArr[index].toLowerCase().trim();
            console.log('vt suche, element', element, item.uid, item.interneid);
            // console.log('Content', item.content);
            if (
              String(item.uid).toLowerCase().indexOf(element) > -1
              || item.interneid.toLowerCase().indexOf(element) > -1
              || item.voort.toLowerCase().indexOf(element) > -1
              || item.voadresse.toLowerCase().indexOf(element) > -1
              || item.sembezall.toLowerCase().indexOf(element) > -1
              || (item.content !== null && item.content.toLowerCase().indexOf(element) > -1)
              || item.refartnummer.toLowerCase().indexOf(element) > -1
              || JSON.stringify(item.dozenten)
                .toLowerCase()
                .indexOf(element) > -1
              || (item.content !== null && item.content.toLowerCase().indexOf(element) > -1)
            ) {
              console.log('treffer');
              treffer += 1;
            }
          }
          return treffer >= searchTermArr.length;
        });
      }
      // console.log('kursliste: ', arr);
      return arr;
    },
  },
});
